import { apiGet, apiPost } from "./client";
import type { FollowUp } from "@career-ops-amplify/shared";

export async function listFollowups(): Promise<{ followups: FollowUp[] }> {
  return apiGet("/api/followups");
}

export async function logFollowup(input: {
  appNum?: number;
  jobId?: string;
  company: string;
  role: string;
  appliedDate?: string;
  nextFollowUp?: string;
  cadenceStatus?: string;
  channel?: string;
  contactName?: string;
  contactId?: string;
  companySlug?: string;
  notes?: string;
}): Promise<{ followup: FollowUp }> {
  return apiPost("/api/followups/log", input);
}
